module.exports = __webpack_public_path__ + "static/tanchoro01-95a93429eb7b97dd31d896b9d5664621.jpg";